export default "__VITE_ASSET__DNqZY8eI__"